export default __webpack_public_path__ + "static/red-matrix-ddf30f497883ccce00fa71db045c3791.svg";